// Figures are keys, not hardcoded numbers: French moves both the word and the space ('82 %').
// The `*_url` keys are still placeholders on `example.com` (grep `_placeholder_`); they are
// keys at all because the destinations are per-market.
export default {
  intro: {
    id: 'rm_take_action_intro',
    defaultMessage:
      'The raw material problem begins before a device reaches the shelf. But we can fight overproduction by avoiding overconsumption',
  },
  stat1Figure: {
    id: 'rm_take_action_stat_production_figure',
    defaultMessage: '16 billion',
  },
  stat1Body: {
    id: 'rm_take_action_stat_production_body',
    defaultMessage: 'Smartphones in circulation worldwide.',
  },
  stat2Figure: {
    id: 'rm_take_action_stat_footprint_figure',
    defaultMessage: '80%',
  },
  stat2Body: {
    id: 'rm_take_action_stat_footprint_body',
    defaultMessage:
      "Of a smartphone's carbon footprint is generated before its first minute of use.",
  },
  stat3Figure: {
    id: 'rm_take_action_stat_materials_figure',
    defaultMessage: '266 kg',
  },
  stat3Body: {
    id: 'rm_take_action_stat_materials_body',
    defaultMessage:
      'The amount of raw materials 1 single smartphone needs, more than 1,000 times its own weight.',
  },
  card1Title: {
    id: 'rm_take_action_lifespan_title',
    defaultMessage: 'We want your phone to last for 10 years.',
  },
  card1Body: {
    id: 'rm_take_action_lifespan_body',
    defaultMessage:
      'The best way to reduce a phone’s impact is to keep it in use. Keeping one phone for 10 years instead of 2.5 can help prevent 757 kg of raw material extraction. Repair, resell, and choose refurbished.',
  },
  card1Cta: {
    id: 'rm_take_action_lifespan_cta',
    defaultMessage: 'Start Now',
  },
  card1Url: {
    id: 'rm_take_action_placeholder_lifespan_url',
    defaultMessage: 'https://example.com/take-action/start-now',
  },
  card2Title: {
    id: 'rm_take_action_petition_title',
    defaultMessage: 'Tell your Rep to support H.R. 7404',
  },
  card2Body: {
    id: 'rm_take_action_petition_body_1',
    defaultMessage:
      'The Fair Repair Act would give owners and independent repair shops fair access to the parts, tools, and software needed to fix digital devices. Tell your representative to support or co-sponsor H.R. 7404.',
  },
  card2Cta: {
    id: 'rm_take_action_petition_cta',
    defaultMessage: 'Speak up',
  },
  card2Url: {
    id: 'rm_take_action_placeholder_petition_url',
    defaultMessage: 'https://example.com/take-action/petition',
  },
} as const
